/* eslint-disable */
<template>
  <!-- eslint-disable -->
<scores />
</template>

<script>
/* eslint-disable */
import forEach from 'lodash/forEach';

export default {
    name: 'Scores',
    data() {
        return ""
    }
}
</script>



<style>
</style>
